//---------	Global imports
import React from 'react';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations';


class ProductDetails extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    this.options = props;
  }
  
  
  //---------	React functions
  componentWillReceiveProps(props) {
    this.options = props;
  }
  
  
  //---------	Render
  render() {
    return (
      <div className="CalipsyProductCustomizer">
        <div className="CalipsyProductDetails-table">
          <div className="CalipsyProductDetails-column"
               onClick={() => this.props.toggleSidebar('activeTab', 'material')}>
            <h5>{ T.productDetails.material }</h5>
            <div>{this.options.material}</div>
          </div>
          <div className="CalipsyProductDetails-column" onClick={() => this.props.toggleSidebar('activeTab', 'color')}>
            <h5>{ T.productDetails.color }</h5>
            <div>{this.options.color}</div>
          </div>
          <div className="CalipsyProductDetails-column" onClick={() => this.props.toggleSidebar('activeTab', 'size')}>
            <h5>{ T.productDetails.size }</h5>
            <div dangerouslySetInnerHTML={{__html: T.customizer.size[this.options.size]}}></div>
          </div>
          <div className="CalipsyProductDetails-column"
               onClick={() => this.props.toggleSidebar('activeTab', 'pattern')}>
            <h5>{ T.productDetails.pattern }</h5>
            <div>{this.options.pattern}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetails;


// WEBPACK FOOTER //
// ./src/components/ProductDetails/index.js